// This function is for the down payment percent values in the Payment Calculator
function getPaymentCalculatorDownPaymentPercent(column = 0, askingPrice = undefined) {
    return askingPrice >= 1_000_000
        ? DEFAULT_DOWN_PAYMENT_PERCENTS_ONE_MILLION[column]
        : DEFAULT_DOWN_PAYMENT_PERCENTS_UNDER_ONE_MILLION[column];
}

// first column is undefined because we should default to minimum down payment
const DEFAULT_DOWN_PAYMENT_PERCENTS_UNDER_ONE_MILLION = [ undefined, 10, 15, 20 ];
const DEFAULT_DOWN_PAYMENT_PERCENTS_ONE_MILLION = [ undefined, 25, 30, 35 ];

export default getPaymentCalculatorDownPaymentPercent; 